import { UseI18nHook } from "@core/i18n/i18n";
import { UseNavigationHook } from "@core/routing/use-navigate";
import { Notification, PatientNotificationData, PtNotificationData } from "@domain/notification/notification";
import { RoutesPath } from "@ui/navigation/routes";
import { formatName } from "@utils/string-utils";

export class HctInvitationSentNotification extends Notification {
	private get data() {
		return this.notification.data as {
			patient: PatientNotificationData;
			invitingPt: PtNotificationData;
		};
	}

	format({ format }: UseI18nHook): string {
		return format("global.notifications.hct.invitation", {
			ptName: formatName(this.data.invitingPt),
			patientName: formatName(this.data.patient),
		});
	}

	onClick(navigate: UseNavigationHook): void {
		navigate(RoutesPath.Home, {
			query: { patientId: this.data.patient.id, ptId: this.data.invitingPt.id },
		});
	}
}
